// Import the webcomponent for the burger icon / trigger
import "mburger-webcomponent";

// Module-level state for the mobile menu instance and API
let mobileMenu = null;
let api = null;
let initialized = false;

/**
 * Initialize the mobile menu when needed.
 * - Parses server-provided HTML into DOM nodes
 * - Instantiates Mmenu with the parsed nodes and options
 * - Sets up event listeners for the burger and menu-item navigation
 */
function initMobileMenu() {
	// Prevent double initialization
	if (initialized) {
		return;
	}

	// Parse menu items HTML string into DOM nodes so Mmenu can accept them.
	const tempDiv = document.createElement("div");
	tempDiv.innerHTML = bds_theme.features.mobile_menu.menu_items;
	const menuItems = Array.from(tempDiv.childNodes);

	// Create the Mmenu instance.
	// Spread the parsed menuItems as separate arguments, then pass the two options objects.
	mobileMenu = new Mmenu(
		...menuItems,
		{
			...bds_theme.features.mobile_menu.mmenu_opts,
		},
		{
			classNames: {
				// Map Mmenu's selected class to WP's current menu item class
				selected: "current-menu-item",
			},
			offCanvas: {
				// Do not clone the page when opening the off-canvas panel
				clone: false,
				page: {
					// Ensure the page selector matches the site layout so Mmenu can
					// push the correct content when opening.
					// selector: ".wp-site-blocks",
				},
			},
		},
	);

	// Keep a reference to the Mmenu API for later actions (open, close, openPanel).
	api = mobileMenu.API;

	// Handle burger icon clicks: open the menu panel when a burger is clicked.
	document.querySelectorAll("mm-burger").forEach(function (burger) {
		burger.addEventListener("click", function (event) {
			// Prevent any default behaviour
			event.preventDefault();

			// Guard against missing API
			if (api && api.open) {
				api.open();
			}
		});
	});

	// Some menu items are plain text with href="#" and rely on a "next" button
	// to open a nested panel. Detect clicks on those text nodes and open the
	// appropriate panel instead of following the "#" link.
	document.querySelectorAll(".mm-listitem__text").forEach(function (itemText) {
		itemText.addEventListener("click", function (event) {
			// The clicked element might be a child of the itemText, so use the event target.
			const href = event.target.getAttribute("href");

			// If href ends with '#' then this is a placeholder link that should open a panel.
			if (href && href[href.length - 1] === "#") {
				// The "next" button that opens the panel is expected to be the sibling element
				// with class "mm-btn--next". Check and use its href as the panel identifier.
				const nextBtn = itemText.nextElementSibling;
				if (nextBtn && nextBtn.classList.contains("mm-btn--next")) {
					const panelHref = nextBtn.getAttribute("href");

					// If a panelHref exists, ask the API to open that panel.
					if (panelHref && api && api.openPanel) {
						api.openPanel(panelHref);
					}
				}
			}
		});
	});

	// Mark as initialized so we don't re-create everything on subsequent calls.
	initialized = true;
}

/**
 * Destroy / teardown the mobile menu.
 * - Closes the menu if open
 * - Resets initialization flag
 * - Note: Mmenu may provide a destructor method; call it here if available.
 */
function destroyMobileMenu() {
	// Only act if we previously initialized
	if (!initialized) {
		return;
	}

	// Close the menu if API is available and provides a close method
	if (api && api.close) {
		api.close();
	}

	// If the Mmenu instance exposes a destroy method, call it to remove DOM/listeners.
	// (This is optional and depends on the Mmenu implementation.)
	if (mobileMenu && typeof mobileMenu.destroy === "function") {
		mobileMenu.destroy();
	}

	// Reset local references so a new instance can be created later.
	mobileMenu = null;
	api = null;
	initialized = false;
}

/**
 * Check viewport width and initialize or destroy the mobile menu accordingly.
 * - mobile menu is active below 796px
 */
function checkMobileMenu() {
	if (window.innerWidth < 796) {
		initMobileMenu();
	} else {
		destroyMobileMenu();
	}
}

// Initialize on DOM ready and re-check on resize
document.addEventListener("DOMContentLoaded", function () {
	// Initial check on load
	checkMobileMenu();

	// Re-check on window resize so the mobile menu is created/destroyed appropriately.
	window.addEventListener("resize", function () {
		checkMobileMenu();
	});
});
